export const environment = {
  production: true,

  logger: false,
};



// WEBPACK FOOTER //
// ./ts/environments/environment.ts